<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :state="state">
        <b-input-group :prepend="$t('country')">
            <b-form-select
                    v-model="inputVal"
                    :options="options"
                    :state="state"
                    :disabled="disabled">
            </b-form-select>
        </b-input-group>
    </b-form-group>
</template>

<script>
    export default {
        props: ['model', 'label', 'errors', 'disabled'],
        data() {
            return {
                inputVal: this.model['country'] ? this.model['country'] : null,
                state: null,
                errorTxt: '',
                options: []
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val['country'];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model['country'] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === 'country') {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                this.state = !hasErr;
            }
        },
        methods: {},
        mounted() {
            this.options = [
                {value: null, text: this.$t('select')}
            ];
            this.$bgService.get('/country', {params: {page: 1, pageSize: 1000, status: 0}}).then(response => {
                response.data.docs.forEach(item => {
                    this.options.push({value: item._id, text: item.name});
                });
            });
        },
        i18n: {
            messages: {
                en: {
                    select: 'Select country',
                },
                vi: {
                    select: 'Chọn quốc gia',
                }
            }
        }
    }
</script>